<div class="wrapper">
  <div *ngIf="displayPropriete" class="container-next-step">
    <figure class="icone">
      <img src="{{ 'assets/images/icon-page/icon-propriete.svg' | cheminAbsoluStatique }}" alt="" />
    </figure>
    <h3 class="title dsd-t-4">{{ 'carte-prochaine-etape.propriete.titre' | translate }}</h3>
    <p class="text">{{ 'carte-prochaine-etape.propriete.texte' | translate }}</p>
    <div class="button-next-step">
      <button mat-button (click)="navigateTo('/propriete')" id="propriete" class=" white full-width-xs">
        {{ 'propriete.creation.titre' | translate }}
      </button>
    </div>
    <span class="number">2</span>
  </div>

  <div class="container-next-step" *ngIf="displayPreauth">
    <ng-template #default>
      <div>
        <figure class="icone">
          <img src="{{ 'assets/images/icon-page/icon-preaut.svg' | cheminAbsoluStatique }}" alt="" />
        </figure>
        <h3 class="title dsd-t-4">{{ 'carte-prochaine-etape.preautorisation.titre' | translate }}</h3>
        <p class="text">{{ 'carte-prochaine-etape.preautorisation.texte' | translate }}</p>
        <div class="button-next-step">
          <button mat-button (click)="navigateTo(preautoriationLink)" id="preautorisation" class=" white full-width-xs">
            {{ 'carte-prochaine-etape.preautorisation.bouton' | translate }}
          </button>
        </div>
      </div>
      <span class="number">3</span>
    </ng-template>

    <app-status-preautorisation
      *ngIf="(status$ | async) || (lastPreautorisation$ | async); else default"
    ></app-status-preautorisation>
  </div>

  <div *ngIf="displayOffreAchat" class="container-next-step">
    <figure class="icone">
      <img src="{{ 'assets/images/icon-page/icon-offre.svg' | cheminAbsoluStatique }}" alt="" />
    </figure>
    <h3 class="title dsd-t-4">{{ 'carte-prochaine-etape.offre-achat.titre' | translate }}</h3>
    <p class="text">{{ 'carte-prochaine-etape.offre-achat.texte' | translate }}</p>
    <div class="button-next-step">
      <button mat-button (click)="navigateTo('/offre-achat')" id="offre-achat" class=" white full-width-xs">
        {{ 'carte-prochaine-etape.offre-achat.bouton' | translate }}
      </button>
    </div>
    <span class="number">4</span>
  </div>

  <div *ngIf="displayPretAssurances" class="container-next-step pret-assurances">
    <figure class="icone">
      <img src="{{ 'assets/images/icon-page/icon-assurance.svg' | cheminAbsoluStatique }}" alt="" />
    </figure>
    <h3 class="title dsd-t-4">{{ 'carte-prochaine-etape.pret-assurances.titre' | translate }}</h3>
    <ul class="list-item">
      <li class="item" *ngIf="!activeOctroi">
        <h4 class="title list">{{ 'carte-prochaine-etape.pret-assurances.pret.titre' | translate }}</h4>
        <p class="text">{{ 'carte-prochaine-etape.pret-assurances.pret.texte' | translate }}</p>
        <div class="button-next-step">
          <button mat-button (click)="navigateTo('/octroi', 'pret')" id="pret" class=" white full-width-xs">
            {{ 'carte-prochaine-etape.pret-assurances.pret.bouton' | translate }}
          </button>
        </div>
      </li>
      <li class="item" *ngIf="activeOctroi">
        <h4 class="title list">{{ 'carte-prochaine-etape.pret-assurances.pret.titre' | translate }}</h4>
        <app-status-box-processing
          [textContent]="'carte-prochaine-etape.preautorisation.active.texte' | translate"
        ></app-status-box-processing>
        <div class="button-next-step">
          <button mat-button (click)="navigateTo('/octroi', 'pret')" id="pret" class=" white full-width-xs">
            {{ 'carte-prochaine-etape.pret-assurances.pret.bouton' | translate }}
          </button>
        </div>
      </li>
      <li class="item">
        <h4 class="title list">{{ 'carte-prochaine-etape.pret-assurances.assurance-pret.titre' | translate }}</h4>
        <p class="text">{{ 'carte-prochaine-etape.pret-assurances.assurance-pret.texte' | translate }}</p>
        <div class="button-next-step">
          <button
            mat-button
            (click)="navigateTo('/assurance-pret', 'assurance-pret')"
            id="assurrance-pret"
            class="white full-width-xs"
          >
            {{ 'carte-prochaine-etape.pret-assurances.assurance-pret.bouton' | translate }}
          </button>
        </div>
      </li>
      <li class="item">
        <h4 class="title list">{{ 'carte-prochaine-etape.pret-assurances.assurance-habitation.titre' | translate }}</h4>
        <p class="text">{{ 'carte-prochaine-etape.pret-assurances.assurance-habitation.texte' | translate }}</p>
        <div class="button-next-step">
          <button
            mat-button
            (click)="navigateTo('/assurance-habitation', 'assurance-habitation')"
            id="assurrance-habitation"
            class="white full-width-xs"
          >
            {{ 'carte-prochaine-etape.pret-assurances.assurance-habitation.bouton' | translate }}
          </button>
        </div>
      </li>
    </ul>
    <span class="number">5</span>
  </div>

  <div *ngIf="displayActeVente" class="container-next-step">
    <figure class="icone">
      <img src="{{ 'assets/images/icon-page/icon-acte-vente.svg' | cheminAbsoluStatique }}" alt="" />
    </figure>
    <h3 class="title dsd-t-4">{{ 'carte-prochaine-etape.acte-vente.titre' | translate }}</h3>
    <p class="text">{{ 'carte-prochaine-etape.acte-vente.texte' | translate }}</p>
    <div class="button-next-step">
      <button mat-button (click)="navigateTo('/acte-vente')" id="acte-vente" class=" white full-width-xs">
        {{ 'carte-prochaine-etape.acte-vente.bouton' | translate }}
      </button>
    </div>
    <span class="number">6</span>
  </div>

  <div *ngIf="displayEmmenagement" class="container-next-step">
    <figure class="icone">
      <img src="{{ 'assets/images/icon-page/icon-demenagement.svg' | cheminAbsoluStatique }}" alt="" />
    </figure>
    <h3 class="title dsd-t-4">{{ 'carte-prochaine-etape.emmenagement.titre' | translate }}</h3>
    <p class="text">{{ 'carte-prochaine-etape.emmenagement.texte' | translate }}</p>
    <div class="button-next-step">
      <button mat-button (click)="navigateTo('/emmenagement')" id="emmenagement" class=" white full-width-xs">
        {{ 'carte-prochaine-etape.emmenagement.bouton' | translate }}
      </button>
    </div>
    <span class="number">7</span>
  </div>
</div>
